import { Stack } from '@mantine/core'

export const ShellAside = () => {
  return <Stack>Aside</Stack>
}
